module.exports = __webpack_public_path__ + "img/1080_09.e4ce6479.jpg";